import { classIdx, classifyEqInterval, getClass } from '../../../../lib/classify-series'

function hex2rgb(hex, opacity = 1.0) {
  const str = hex.substring(1)
  const n = parseInt(str, 16)

  const r = (n >> 16) & 255
  const g = (n >> 8) & 255
  const b = n & 255

  return `rgba(${r}, ${g}, ${b}, ${opacity})`
}

export function createClasses(bucketCount: number, farge: string) {
  const positiveClasses = new Array(Math.max(bucketCount, 0)).fill(null).map((_, idx) => {
    const opacity = (1 / bucketCount) * (idx + 1)
    return hex2rgb(farge, opacity)
  })
  const negativeClasses = new Array(Math.max(bucketCount, 0))
    .fill(null)
    .map((_, idx) => {
      const opacity = (1 / bucketCount) * (idx + 1)
      return hex2rgb('#686a6c', opacity)
    })
    .reverse()

  return [...negativeClasses, ...positiveClasses]
}

export function createBounds(values: number[], bucketCount: number) {
  const max = Math.max(...values.map(Math.abs), 4)

  const bounds = classifyEqInterval(values, bucketCount, 0, max).map((v, idx, bounds) => {
    if (idx === 0) return Math.floor(v)
    if (idx === bounds.length - 1) return Math.ceil(v)
    return Math.round(v)
  })
  const negativeBounds = bounds
    .map(a => -1 * a)
    .reverse()
    .filter(a => a !== 0)
  return [...negativeBounds, ...bounds]
}

export type ClassEntry = { clazz: string; idx: number; knrs: number[] }

export function createClassList(entries, bounds, classes) {
  const classMap = entries
    .map(([id, value]) => ({ id, value: value === 0 ? undefined : value }))
    .reduce(
      (acc, { id, value }) => {
        const idx = classIdx(bounds, value)
        const clazz = getClass(bounds, value, classes, '#ffffff')
        const classInfo = acc[clazz] || { clazz, idx, knrs: [] }
        classInfo.knrs.push(id)
        acc[clazz] = classInfo
        return acc
      },
      {} as { [key: number]: ClassEntry }
    )

  return classes.map((clazz, idx) => classMap[clazz] || { clazz, idx, knrs: [] })
}
